'use strict';

var palette = require('./palette.js');
var typography = require('./typography.js');
var spacing = require('./spacing.js');
var radiuses = require('./radiuses.js');
var shadows = require('./shadows.js');
var zIndices = require('./z-indices.js');
var breakpoints = require('./breakpoints.js');
var index = require('./design-tokens/index.js');
var animations = require('./animations.js');

const themeWithoutDesignTokens = {
    breakpoints: breakpoints.breakpoints,
    colors: palette.colors,
    devices: breakpoints.devices,
    palette: palette.palette,
    radiuses: radiuses.radiuses,
    shadows: shadows.shadows,
    space: spacing.space,
    transition: animations.transition,
    typography: typography.typography,
    zIndices: zIndices.zIndices,
};
const theme = {
    designTokens: index.designTokens(themeWithoutDesignTokens),
    deviceMediaQueries: breakpoints.makeMediaQueries(themeWithoutDesignTokens.devices),
    ...themeWithoutDesignTokens,
};

exports.theme = theme;
exports.themeWithoutDesignTokens = themeWithoutDesignTokens;
//# sourceMappingURL=theme.js.map
